import { cn } from '@/utils'
import { sourceHref } from '../columns'

interface PageLinkProps {
  fileUrl: string
  page: number | null
  className?: string
}

// The small green "Page 7" after a printed figure. With no page sent, it opens the statement.
export const PageLink = ({ fileUrl, page, className }: PageLinkProps) => {
  if (!fileUrl) return null
  return (
    <a
      href={sourceHref({ statementFileUrl: fileUrl, sourcePage: page })}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'cursor-pointer whitespace-nowrap text-xs font-medium text-brand-deep hover:underline',
        className,
      )}
    >
      {page ? `Page ${page}` : 'Statement'}
    </a>
  )
}
